import { Logger } from "shared/lib/Logger"
import { useEvent } from "shared/lib/useEvent"

import { useGetTeamMember } from "entities/team-members/model/useGetTeamMember"

import { TeamScopedTeamMemberActionHandlers } from "../types/TeamScopedTeamMemberActionHandlers"
import { useTeamMemberActionHandlers } from "./useTeamMemberActionHandlers"

export function useTeamScopedTeamMemberActionHandlers(
  teamID: string
): TeamScopedTeamMemberActionHandlers {
  const {
    handleDeleteTeamMember: deleteTeamMember,
    handleResendTeamMemberInvitation: resendTeamMemberInvitation
  } = useTeamMemberActionHandlers()

  const getTeamMember = useGetTeamMember()

  const handleDeleteTeamMember = useEvent((teamMemberID: string) => {
    const teamMember = getTeamMember(teamMemberID)

    if (!teamMember) {
      Logger.warn(
        "CacheMissError",
        `TeamMember ${teamMemberID} not found in cache`
      )
      return undefined
    }

    return deleteTeamMember({ teamMember, teamID })
  })

  const handleResendInvitation = useEvent((teamMemberID: string) => {
    return resendTeamMemberInvitation({ teamID, teamMemberID })
  })

  return {
    handleDeleteTeamMember,
    handleResendInvitation
  }
}
